import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableAppBlackoutsPostalCodesCatalog from './tableAppBlackoutsPostalCodesCatalog';

export default {
  title: 'General',
  attributeName: 'blackouts',
  fields: [
    {
      attributeName: 'mode',
      helpText: 'Mode',
      type: FormInputTypes.SELECT,
      label: 'Mode',
      placeholder: 'Please enter a mode ...',
      multiple: false,
      emptyValue:true,
      default:'(Empty)', //default value to empty option
      options: [
        { name: 'Manual', value: 'manual' },
        { name: 'Automatic (From AI)', value: 'automatic' },
      ],
    },
    {
      attributeName: 'tagName',
      helpText: 'Name of the tag',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Tag Name',
      placeholder: 'Name...',
      visibleWhen:[{"field":"mode",value:"manual"}]
    },
    {
      attributeName: 'tagType',
      label: 'Tag Type',
      helpText: 'Type of the tag.',
      default: 'enabled',
      type: FormInputTypes.SELECT,
      options: [
        { name: 'Context', value: 'context' },
        { name: 'Actor', value: 'actor' },
      ],
      visibleWhen:{"field":"mode","value":"manual"},

    },
    {
      attributeName: 'score',
      helpText: 'Score of the tag',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Score',
      placeholder: 'Score...',
      visibleWhen:{"field":"mode","value":"manual"},

    },

    {
      attributeName: 'context',
      helpText: 'context to send to AI to get the tags',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      multiline:true,
      label: 'Context (AI input)',
      placeholder: 'Context...',
      visibleWhen:{"field":"mode","value":"automatic"},

    },
  ],
};
